import { render, staticRenderFns } from "./LocalPharmacyIcon.vue?vue&type=template&id=2ce91e4a&scoped=true&"
import script from "./LocalPharmacyIcon.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LocalPharmacyIcon.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce91e4a",
  null
  
)

export default component.exports